<div class="container-fluid mt-3">
  <div class="row">
    <div class="col-12 col-xl-12 pb-3">
      <div class="card data-card">
        <div class="card-chart-body">
          <div class="card-chart-content">
            <h6 class="card-title" translate>
              DASHBOARD_LBL_CHART_CA_MONTHLY_PROGRESS
<!--              <i-->
<!--                class="mdi mdi-information-outline"-->
<!--                placement="bottom"-->
<!--                [ngbTooltip]="'' | translate"-->
<!--              ></i>-->
            </h6>
            <div class="card-chart">
              <canvas
                id="monthlyProgressChart"
                style="display: block; box-sizing: border-box; height: 248px"
              >
              </canvas>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-4 col-xl-4 pb-3">
      <div class="card data-card">
        <div class="card-chart-body">
          <div class="card-chart-content">
            <h6 class="card-title" >
              <span translate>DASHBOARD_LBL_CHART_CA_DAY</span>
              @if (!!titleDailySalesChart()) {
                :
              }
              <span>{{ this.titleDailySalesChart() }}</span>
<!--              <i-->
<!--                class="mdi mdi-information-outline"-->
<!--                placement="bottom"-->
<!--                [ngbTooltip]="-->
<!--                  '' | translate-->
<!--                "-->
<!--              ></i>-->
            </h6>
            <div class="card-chart">
              <canvas
                id="dailySalesChart"
                style="
                  display: block;
                  box-sizing: border-box;
                  height: 190px;
                  width: 768px;
                "
              ></canvas>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-4 col-xl-4 pb-3">
      <div class="card data-card">
        <div class="card-chart-body">
          <div class="card-chart-content">
            <h6 class="card-title" >
              <span translate>DASHBOARD_LBL_CHART_CA_MONTH</span>
              @if (!!titleMonthlySalesChart()) {
                :
              }
              <span>{{ this.titleMonthlySalesChart() }}</span>
<!--              <i-->
<!--                class="mdi mdi-information-outline"-->
<!--                placement="bottom"-->
<!--                [ngbTooltip]="-->
<!--                  '' | translate-->
<!--                "-->
<!--              ></i>-->
            </h6>
            <div class="card-chart">
              <canvas
                id="monthlySalesChart"
                style="display: block; box-sizing: border-box; height: 190px"
              >
              </canvas>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-4 col-xl-4 pb-3">
      <div class="card data-card">
        <div class="card-chart-body">
          <div class="card-chart-content">
            <h6 class="card-title" >
              <span translate>DASHBOARD_LBL_CHART_CA_YEAR</span>
                @if (!!titleYearlySalesChart()) {
                  :
                }
                <span>{{ this.titleYearlySalesChart() }}</span>
<!--              <i-->
<!--                class="mdi mdi-information-outline"-->
<!--                placement="bottom"-->
<!--                [ngbTooltip]="-->
<!--                  '' | translate-->
<!--                "-->
<!--              ></i>-->
            </h6>
            <div class="card-chart">
              <canvas
                id="yearlySalesChart"
                style="
                  display: block;
                  box-sizing: border-box;
                  height: 190px;
                  width: 768px;
                "
              ></canvas>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
